export default __webpack_public_path__ + "images/0x12841b5c2e6a793009747e0e331e446b0064a064.png";